<template lang="pug">
div
    // h1 {{ $t("routesMenu.CustomizeDashboard") }}
    template(v-if="$store.state.queryGroupName == 'all'")
        Card
            div(style="text-align: center")
                h3 Please choose a group to build your chart.
    template(v-else)
        Row(type="flex", justify="space-around", style="padding-bottom: 15px")
            Col(span="24")
                Dropdown(trigger="click", placement="bottom-start")
                    Button(size="small", type="primary", icon="ios-arrow-down") Add Chart
                    DropdownMenu(slot="list", style="width: 300px")
                        DropdownItem(v-on:click.native="showChartLibrarySelector")
                            Icon(type="md-book", style="margin-right: 8px")
                            span Quick Add
                            span(style="float: right; color: rgb(204, 204, 204)") Select Chart From Library
                        DropdownItem(v-on:click.native="showCustomizeChartForm")
                            Icon(type="md-build", style="margin-right: 8px")
                            span Chart Builder
                            span(style="float: right; color: rgb(204, 204, 204)") Build Your Own Chart
                Button(
                    @click="saveDashboard",
                    size="small",
                    :type="hasDashboardChanged ? 'info' : 'default'",
                    :disabled="!hasDashboardChanged"
                ) Save
                Dropdown(trigger="click", placement="bottom-start")
                    Button(size="small", icon="ios-arrow-down") Export / Import
                    DropdownMenu(slot="list", style="width: 300px")
                        DropdownItem(v-on:click.native="exportDashboardCharts")
                            Icon(type="ios-download-outline", style="margin-right: 8px")
                            span Export Current Dashboard
                        DropdownItem(v-on:click.native="showImportDashboardModal")
                            Icon(type="ios-cloud-upload-outline", style="margin-right: 8px")
                            span Import From Saved Dashboard
                div(style="float: right")
                    SearchChartBtn(searchBtnIcon="md-refresh" searchBtnSize="small" )
                    Dropdown(trigger="click", placement="bottom-start")
                        Button(
                            size="small",
                            icon="ios-arrow-down",
                            :type="autoRefreshInterval !== 'off' ? 'primary' : 'default'"
                        ) Auto {{ autoRefreshInterval }}
                        DropdownMenu(slot="list", style="width: 300px")
                            DropdownItem(
                                v-for="refreshOption in autoRefreshIntervalOptions",
                                :key="refreshOption.value",
                                v-on:click.native="setReloadInterval(refreshOption.name)"
                            )
                                Icon(type="ios-md-refresh", style="margin-right: 8px")
                                span {{ refreshOption.name }}
        Row(type="flex", justify="space-around", style="padding-bottom: 15px")
            Col(span="4")
                ChartFilterSelector(
                    v-model="dashboardQueryFilters",
                    @input="dashboardQueryFiltersChanged",
                    @contentChanged="dashboardQueryFiltersChanged",
                    ref="DashboardChartFilterSelector"
                )
            Col(span="5")
                DateRangeSelector(:customTimeRangeOptions="this.customTimeRangeOptions" :dateRangeLimit="this.dateRangeLimit")
            Col(span="15")
        ChartLibrarySelector(@input="addItem", ref="ChartLibrarySelector") 
        Modal(
            title="Import",
            v-model="isImportDashboardModalShow",
            width="1200",
            :mask-closable="false",
            :styles="{ top: '20px' }"
        )
            // Input(v-model="importDashboardChartsData" type="textarea" :rows="30" placeholder="Paste your saved dashboard here")
            p Replace below content with your saved dashboard.
            CodeEditor(v-model="importDashboardChartsData", :formItem="{ codeEditorLanguage: 'js' }")
            div(slot="footer")
                Button(@click="importDashboardCharts", type="primary", long) Update
        Modal(
            title="Build your chart",
            v-model="isModalShow",
            width="1200",
            @on-visible-change="handleOnVisibleChange",
            :mask-closable="false",
            :styles="{ top: '20px' }"
        )
            // 避免沒顯示也獲取了第一次資料
            Card(v-if="isModalShow")
                p(style="text-align: center; font-weight: bold; padding-bottom: 10px") {{ customizeChartForm.chartTitle }}
                CDNChart(
                    :category="'newChart'"
                    ref="CDNChartPreview",
                    :chartTitle="customizeChartForm.chartTitle",
                    :chartVisualizeType="customizeChartForm.chartVisualizeType",
                    :chartMetric="customizeChartForm.chartMetric",
                    :chartMetricGroupBy="customizeChartForm.chartMetricGroupBy",
                    :chartMetricGroupByTerms="customizeChartForm.chartMetricGroupByTerms",
                    :chartMetricGroupByTermSize="customizeChartForm.chartMetricGroupByTermSize",
                    :chartMetricGroupByFilters="customizeChartForm.chartMetricGroupByFilters",
                    :chartQueryFilters="customizeChartForm.chartQueryFilters",
                    :dashboardQueryFilters="dashboardQueryFilters",
                    style="height: 250px"
                )
            Row(style="padding: 15px", type="flex", justify="space-around")
                Col(span="4")
                    Card(
                        :class="cardPointerClass(customizeChartForm.chartVisualizeType == 'lineChart')",
                        v-on:click.native="selectChartVisualizeType('lineChart')"
                    )
                        h4 Line
                        img.chart-logo(src="/static/img/charts/line_chart.svg")
                Col(span="4")
                    Card(
                        :class="cardPointerClass(customizeChartForm.chartVisualizeType == 'barChartHorizontal')",
                        v-on:click.native="selectChartVisualizeType('barChartHorizontal')"
                    )
                        h4 Horizontal Bar
                        img.chart-logo(src="/static/img/charts/bar_chart_horizontal.svg")
                Col(span="4")
                    Card(
                        :class="cardPointerClass(customizeChartForm.chartVisualizeType == 'barChartVertical')",
                        v-on:click.native="selectChartVisualizeType('barChartVertical')"
                    )
                        h4 Vertical Bar
                        img.chart-logo(src="/static/img/charts/bar_chart_vertical.svg")
                Col(span="4")
                    Card(
                        :class="cardPointerClass(customizeChartForm.chartVisualizeType == 'pieChart')",
                        v-on:click.native="selectChartVisualizeType('pieChart')"
                    )
                        h4 Pie
                        img.chart-logo(src="/static/img/charts/pie_chart.svg")
                Col(span="4")
                    Card(
                        :class="cardPointerClass(customizeChartForm.chartVisualizeType == 'singleNumberChart')",
                        v-on:click.native="selectChartVisualizeType('singleNumberChart')"
                    )
                        h4 Number
                        img.chart-logo(src="/static/img/charts/number1.svg")
            Divider Settings
            Form(:model="customizeChartForm", :rules="cloudFormValidate", ref="customizeChartForm")
                Row
                    Col(span="12")
                        FormItem(label="Chart Name", prop="chartTitle")
                            Input(v-model="customizeChartForm.chartTitle", style="width: 380px", size="small")
                        FormItem(label="Metric", prop="chartMetric")
                            FormSelect(
                                v-model="customizeChartForm.chartMetric",
                                :formData="customizeChartForm",
                                :formItem="chartMetricParams",
                                style="width: 450px"
                            )
                        FormItem(label="Group By", prop="chartMetricGroupBy")
                            FormSelect(
                                v-model="customizeChartForm.chartMetricGroupBy",
                                :formData="customizeChartForm",
                                :formItem="chartMetricGroupByParams",
                                style="width: 450px"
                            )
                        FormItem(
                            label="Term",
                            prop="chartMetricGroupByTerms",
                            v-if="customizeChartForm.chartMetricGroupBy == 'terms'"
                        )
                            FormSelect(
                                v-model="customizeChartForm.chartMetricGroupByTerms",
                                :formData="customizeChartForm",
                                :formItem="chartMetricGroupByTermsParams",
                                style="width: 300px"
                            )
                        FormItem(
                            label="Size",
                            prop="chartMetricGroupByTermSize",
                            v-if="customizeChartForm.chartMetricGroupBy == 'terms'"
                        )
                            InputNumber(
                                v-model="customizeChartForm.chartMetricGroupByTermSize"
                                :min="1"
                                :max="10"
                                :active-change="false"
                                @on-change="$refs.CDNChartPreview.getDataAndDraw()"
                                style="width: 300px"
                            )
                        FormItem(
                            label="Filters",
                            prop="chartMetricGroupByFilters",
                            v-if="customizeChartForm.chartMetricGroupBy == 'filters'"
                        )
                            ChartFilterSelector(
                                v-model="customizeChartForm.chartMetricGroupByFilters",
                                :formData="customizeChartForm",
                                @input="$refs.CDNChartPreview.getDataAndDraw()",
                                @contentChanged="$refs.CDNChartPreview.getDataAndDraw()"
                            )
                    Col(span="12")
                        FormItem(label="", prop="chartQueryFilters")
                            p Add some additional data queries in this chart, queries added here only effect current chart
                            ChartFilterSelector(
                                v-model="customizeChartForm.chartQueryFilters",
                                @input="$refs.CDNChartPreview.getDataAndDraw()",
                                @contentChanged="$refs.CDNChartPreview.getDataAndDraw()"
                            )

            div(slot="footer")
                Button(@click="addItem(customizeChartForm)", type="primary", long, v-if="editingIndex == -1") Add
                Button(@click="saveItem", type="primary", long, v-else) Save

        //- h1 {{ customizeChartForm }}

        grid-layout(
            :layout.sync="dashboardCharts",
            :col-num="dashboardColNum",
            :row-height="30",
            :is-draggable="true",
            :is-resizable="true",
            :vertical-compact="true",
            :use-css-transforms="true",
            @layout-updated="hasDashboardChanged = true") 
            grid-item(
                v-for="item in dashboardCharts",
                :key="item.i",
                :static="item.static",
                :x="item.x",
                :y="item.y",
                :w="item.w",
                :h="item.h",
                :i="item.i",
                :minW="item.minW",
                :minH="item.minH",
                drag-allow-from=".vue-draggable-handle",
                drag-ignore-from=".no-drag")
                // span.text {{ item.i }}
                // p {{ item }}
                Row.vue-draggable-handle(type="flex" justify="center")
                    Dropdown(trigger="click")
                        span(href="javascript:void(0)", style="cursor: pointer; font-weight: bold") {{ item.chartParams.chartTitle }}
                            Icon(type="ios-arrow-down")
                        DropdownMenu(slot="list", style="text-align: left")
                            DropdownItem(v-on:click.native="editItem(item)")
                                Icon(type="md-create", style="margin-right: 8px")
                                span Edit
                            DropdownItem(v-on:click.native="removeItem(item.i)")
                                Icon(type="md-trash", style="margin-right: 8px")
                                span Delete

                // span.remove(@click="removeItem(item.i)" v-if="isDashboardEditing") x
                // span.edit(@click="editItem(item)" v-if="isDashboardEditing") Edit
                // p(style="text-align: center; font-weight: bold;") {{ item.chartParams.chartTitle }}
                CDNChart(
                    :ref="'CDNChartDashboard-' + item.i",
                    :chartTitle="item.chartParams.chartTitle",
                    :chartVisualizeType="item.chartParams.chartVisualizeType",
                    :chartMetric="item.chartParams.chartMetric",
                    :chartMetricGroupBy="item.chartParams.chartMetricGroupBy",
                    :chartMetricGroupByTerms="item.chartParams.chartMetricGroupByTerms",
                    :chartMetricGroupByTermSize="item.chartParams.chartMetricGroupByTermSize",
                    :chartMetricGroupByFilters="item.chartParams.chartMetricGroupByFilters",
                    :chartQueryFilters="item.chartParams.chartQueryFilters",
                    :dashboardQueryFilters="dashboardQueryFilters",
                    :chartIndex="item.i",
                    @onLegendClick="onChartLegendClick",
                    style="height: 100%; padding: 25px 10px"
                )
</template>
<script>
import { GridLayout, GridItem } from "vue-grid-layout";
import { getFormOptions } from "@/api/formoptions";
import FormSelect from "@/components/rcmTableFormItems/Select/index.js";
import { _uuid, isValidJsonString } from "@/libs/utils";

import colorScheme from "@/data/colorScheme";

import CDNChart from "@/components/dashboard/CDNChart";

import bus from "@/libs/bus.js";
import { _getDashboard, _updateDashboard } from "@/api/rest";
import ChartFilterSelector from "@/components/FormItems/ChartFilterSelector";
import ChartLibrarySelector from "@/components/FormItems/ChartLibrarySelector";

import CodeEditor from "@/components/rcmTableFormItems/CodeEditor";
import DateRangeSelector from "@/components/FormItems/DateRangeSelector";
import { getLicenseInfo, getLicenseInfoOption } from "@/api/system.js";
import SearchChartBtn from "@/components/SearchChartBtn";

export default {
    components: {
        GridLayout,
        GridItem,
        FormSelect,
        CDNChart,
        ChartFilterSelector,
        ChartLibrarySelector,
        CodeEditor,
        DateRangeSelector,
        SearchChartBtn,
    },
    data() {
        return {
            colorScheme,
            isModalShow: false,
            dashboardQueryFilters: [],
            customizeChartForm: {
                chartTitle: "New_Chart",
                chartMetric: "count",
                chartMetricGroupBy: "none",
                chartMetricGroupByTerms: "",
                chartMetricGroupByTermSize: 3,
                chartVisualizeType: "lineChart",
                chartMetricGroupByFilters: [],
                chartQueryFilters: [],
            },
            isImportDashboardModalShow: false,
            importDashboardChartsData: "",
            autoRefreshInterval: "off",
            autoRefreshIntervalOptions: [
                { name: "off", value: null },
                { name: "1 min", value: 60 },
            ],
            autoRefreshIntervalId: null,
            cloudFormValidate: {
                // chartTitle: [
                //     {
                //         required: true,
                //         message: `missing chartTitle`,
                //         trigger: "blur",
                //     },
                // ],
                // chartMetric: [
                //     {
                //         required: true,
                //         message: `missing chartMetric`,
                //         trigger: "blur",
                //     },
                // ],
            },
            chartMetricParams: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartMetric = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-metric?${queryString}`);
                    // console.log("chartMetricParams>>>",`/chart-metric?${queryString}`)
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "chartVisualizeType", queryIf: (val) => val !== "" }],
                onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "count",
                watchField: (value, formData) => {
                    this.$refs.CDNChartPreview.getDataAndDraw();
                },
            },
            chartMetricGroupByParams: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartMetricGroupBy = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-metric-group-by?${queryString}`);
                    // console.log("result>>>",JSON.stringify(result.data.options))
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "chartMetric", queryIf: (val) => val !== "" }],
                onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "none",
                watchField: (value, formData) => {
                    this.$refs.CDNChartPreview.getDataAndDraw();
                },
            },
            chartMetricGroupByTermsParams: {
                remoteOptions: async (queryValue, queryParams) => {
                    queryParams.chartMetricGroupByTerms = queryValue;
                    let queryString = new URLSearchParams(queryParams).toString();
                    let result = await getFormOptions(`/chart-metric-group-by-terms?${queryString}`);
                    // console.log("chartMetricGroupByTermsParams>>>",`/chart-metric-group-by-terms?${queryString}`)
                    return result.data.options;
                },
                queryParamsFields: [{ fieldName: "chartMetric", queryIf: (val) => val !== "" }],
                onQueryParamFieldsQueryIf: "firstAvailable",
                multiple: false,
                defaultVal: "none",
                watchField: (value, formData) => {
                    this.$refs.CDNChartPreview.getDataAndDraw();
                },
            },
            dashboardColNum: 24,
            dashboardCharts: [],
            currentIndex: 0,
            editingIndex: -1,
            chartCardWidth: 6,
            chartCardHeight: 6,
            chartCardWidthMin: 3,
            chartCardHeightMin: 4,
            hasDashboardChanged: false,
            customTimeRangeOptions: [],
            dateRangeLimit: 90,
        };
    },
    // computed: {},
    async created() {
        // window.addEventListener("beforeunload", this.remindSaveDashboard);
        await this.setCustomTimeRangeOption();
    },
    mounted() {
        this.currentIndex = _uuid();
        this.loadDashboard();
        bus.$on("searchChartData", this.reloadDashboardCharts);
    },
    beforeDestroy() {
        bus.$off("searchChartData", this.reloadDashboardCharts);
    },
    // beforeDestroy() {
    //     window.removeEventListener("beforeunload", this.remindSaveDashboard);
    // },
    // beforeRouteLeave(to, from, next) {
    //     const answer = window.confirm("Do you really want to leave? you have unsaved changes!");
    //     if (answer) {
    //         next();
    //     } else {
    //         next(false);
    //     }
    // },
    methods: {
        onChartLegendClick(data) {
            let { name, chartIndex } = data;
            let chartData = this.dashboardCharts.find((e) => e.i == chartIndex);
            if (chartData.chartParams.chartMetric == "unique") return;
            if (chartData.chartParams.chartMetricGroupBy == "none") return;

            let applyFilterData = {
                chartFilterKey: "",
                chartFilterOperator: "is",
                chartFilterValue: "",
                chartFilterLabel: "",
                chartFilterEnabled: true,
            };

            // console.log(chartData.chartParams);
            if (chartData.chartParams.chartMetricGroupBy == "terms") {
                applyFilterData.chartFilterKey = chartData.chartParams.chartMetricGroupByTerms;
                applyFilterData.chartFilterValue = name;
                applyFilterData.chartFilterLabel = `${chartData.chartParams.chartMetricGroupByTerms}:${name}`;
            } else if (chartData.chartParams.chartMetricGroupBy == "filters") {
                let existedFilterData = chartData.chartParams.chartMetricGroupByFilters.find(
                    (e) => e.chartFilterLabel == name
                );
                applyFilterData.chartFilterKey = existedFilterData.chartFilterKey;
                applyFilterData.chartFilterValue = existedFilterData.chartFilterValue;
                applyFilterData.chartFilterLabel = name;
            }
            this.$refs.DashboardChartFilterSelector.applyNewChartFilter(applyFilterData);
        },
        remindSaveDashboard(event) {
            event.preventDefault();
            event.returnValue = "";
        },
        loadDashboard() {
            let groupName = this.$store.state.queryGroupName;
            let dashboardName = this.$route.params.dashboardName;
            let resourceId = `${groupName}-${dashboardName}`;
            _getDashboard(resourceId, groupName)
                .then((result) => {
                    // console.log(result);
                    let { dashboardCharts, dashboardQueryFilters } = result.data.data;

                    // 預防有的圖表缺失設定
                    this.dashboardCharts = dashboardCharts.map((chart) => {
                        chart.minW = this.chartCardWidthMin;
                        chart.minH = this.chartCardHeightMin;
                        return chart;
                    });
                    this.dashboardQueryFilters = dashboardQueryFilters;
                    // console.log(this.dashboardCharts, "dashboardCharts");
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        saveDashboard() {
            // this.dashboardCharts = this.dashboardCharts.map((e) => {
            //     e.i = e.i.toString();
            //     e.chartParams.chartTitle = e.chartParams.chartName;
            //     return e;
            // });
            _updateDashboard(`${this.$store.state.queryGroupName}-${this.$route.params.dashboardName}`, {
                groupName: this.$store.state.queryGroupName,
                dashboardCharts: this.dashboardCharts,
                dashboardQueryFilters: this.dashboardQueryFilters,
            })
                .then((result) => {
                    this.$Message.success("DASHBOARD SAVE!");
                    this.hasDashboardChanged = false;
                })
                .catch((err) => {
                    console.log(err);
                });
        },
        selectChartVisualizeType(chartVisualizeType) {
            if (this.customizeChartForm.chartVisualizeType !== chartVisualizeType) {
                this.customizeChartForm.chartVisualizeType = chartVisualizeType;
                this.$refs.CDNChartPreview.getDataAndDraw();
            }
        },
        cardPointerClass(isActive) {
            return isActive ? "cardPointer cardPointer-active" : "cardPointer";
        },
        showCustomizeChartForm() {
            this.isModalShow = true;
            // this.$refs.CDNChartPreview.getDataAndDraw();
        },
        showChartLibrarySelector() {
            this.$refs.ChartLibrarySelector.isModalShow = true;
        },
        handleOnVisibleChange(visible) {
            if (!visible) {
                console.log("HANDLE CLOSE");
                this.$refs.customizeChartForm.resetFields();
                this.isModalShow = false;
                this.editingIndex = -1;
            }
        },
        saveItem() {
            let index = this.dashboardCharts.findIndex((item) => item.i == this.editingIndex);
            this.dashboardCharts[index].chartParams = Object.assign({}, this.customizeChartForm);
            this.reloadDashboardCharts();
            this.isModalShow = false;
            this.hasDashboardChanged = true;
        },
        addItem(chartParams) {
            let { currentGroupResourceLimits } = this.$store.getters;
            let chartsLimit = currentGroupResourceLimits.maxCustomizeDashbaordChartsCount || 10;
            if (this.dashboardCharts.length >= chartsLimit) {
                return this.$Message.warning(`EXCEED MAX CHART OF: ${chartsLimit}`);
            }

            this.dashboardCharts.push({
                x: (this.dashboardCharts.length * this.chartCardWidth) % this.dashboardColNum,
                y: this.dashboardCharts.length + this.dashboardColNum, // puts it at the bottom
                w: this.chartCardWidth,
                h: this.chartCardHeight,
                i: this.currentIndex,
                minW: this.chartCardWidthMin,
                minH: this.chartCardHeightMin,
                chartParams: Object.assign({}, chartParams),
            });
            this.currentIndex = _uuid();
            this.reloadDashboardCharts();
            this.isModalShow = false;
            this.hasDashboardChanged = true;
        },
        removeItem(itemIndex) {
            let index = this.dashboardCharts.findIndex((item) => item.i == itemIndex);
            this.dashboardCharts.splice(index, 1);
            this.hasDashboardChanged = true;
        },
        editItem(data) {
            // console.log(data);
            this.editingIndex = data.i;
            this.customizeChartForm = Object.assign({}, data.chartParams);
            this.showCustomizeChartForm();
        },
        reloadDashboardCharts() {
            var self = this;
            let chartsRefs = this.dashboardCharts.map((e) => `CDNChartDashboard-${e.i}`);
            this.$nextTick(() => {
                chartsRefs.forEach((ref) => {
                    self.$refs[ref][0].getDataAndDraw();
                });
            });
        },
        dashboardQueryFiltersChanged() {
            this.reloadDashboardCharts();
            this.hasDashboardChanged = true;
        },
        exportDashboardCharts() {
            let data = {
                groupName: this.$store.state.queryGroupName,
                dashboardCharts: this.dashboardCharts,
                dashboardQueryFilters: this.dashboardQueryFilters,
            };
            let blob = new Blob([JSON.stringify(data, null, 2)]);
            let blobUrl = window.URL.createObjectURL(blob);
            let link = document.createElement("a");

            link.href = blobUrl;
            link.download = "dashboard.json";

            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },
        showImportDashboardModal() {
            let data = {
                groupName: this.$store.state.queryGroupName,
                dashboardCharts: this.dashboardCharts,
                dashboardQueryFilters: this.dashboardQueryFilters,
            };
            this.importDashboardChartsData = JSON.stringify(data, null, 2);
            this.isImportDashboardModalShow = true;
        },
        importDashboardCharts() {
            if (!isValidJsonString(this.importDashboardChartsData))
                return this.$Message.warning("DATA SEEMS NOT VALID");
            let data = JSON.parse(this.importDashboardChartsData);

            let { dashboardCharts, dashboardQueryFilters } = data;
            // 預防有的圖表缺失設定
            this.dashboardCharts = dashboardCharts.map((chart) => {
                chart.minW = this.chartCardWidthMin;
                chart.minH = this.chartCardHeightMin;
                return chart;
            });
            this.dashboardQueryFilters = dashboardQueryFilters;

            this.importDashboardChartsData = "";
            this.$Message.success("DASHBOARD UPDATED");
            this.hasDashboardChanged = true;
            this.isImportDashboardModalShow = false;
        },
        setReloadInterval(name) {
            let intervalOption = this.autoRefreshIntervalOptions.find((e) => e.name == name);
            this.autoRefreshInterval = intervalOption.name;

            clearInterval(this.autoRefreshIntervalId);
            this.autoRefreshIntervalId = null;

            if (intervalOption.name == "off") return;

            var self = this;
            this.autoRefreshIntervalId = setInterval(function () {
                self.reloadDashboardCharts();
            }, intervalOption.value * 1000);
        },
        async setCustomTimeRangeOption() {
            const licenseInfo = await getLicenseInfo();
            if (!licenseInfo.data.success) {
                return;
            }

            const dashboardTimeRange = licenseInfo.data.mapData.find((license) => license.name == "dashboardTimeRange");
            const customizeDashboard = dashboardTimeRange.customizeDashboard || [];
            if (customizeDashboard.length == 0) {
                return;
            }

            const selectOptions = await getLicenseInfoOption();
            if (!selectOptions.data.success) {
                return;
            }

            const customizeDashboardOptions = selectOptions.data.mapData.customizeDashboard.value;
            if (customizeDashboardOptions.length == 0) {
                return;
            }

            this.customTimeRangeOptions = customizeDashboard.map((item) => {
                const findSelectOption = customizeDashboardOptions.find((e) => e.value == item.value);
                if (findSelectOption) {
                    item = findSelectOption;
                }
                return item;
            });

            this.dateRangeLimit = customizeDashboard.find((item) => item.value == "99")
                ? customizeDashboard.find((item) => item.value == "99").dateRangeLimit
                : 0;
        },
    },
};
</script>

<style scoped>
.vue-grid-layout {
    background: #eee;
}
.vue-grid-item:not(.vue-grid-placeholder) {
    /* background: #ccc; */
    border: 1px solid black;
}
.vue-grid-item .resizing {
    opacity: 0.9;
}
.vue-grid-item .static {
    background: #cce;
}
.vue-grid-item .text {
    font-size: 24px;
    text-align: center;
    position: absolute;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    margin: auto;
    height: 100%;
    width: 100%;
}
.vue-grid-item .no-drag {
    height: 100%;
    width: 100%;
}
.vue-grid-item .minMax {
    font-size: 12px;
}
.vue-draggable-handle {
    text-align: center;
    transition: 0.3s;
}

.vue-draggable-handle:hover {
    background-color: #f4511e;
}

.cardPointer {
    transform: scale(0.98);
    cursor: pointer;
    margin: 6px 6px 0px 6px;
    background: #fff;
    color: black;
    text-align: center;
}
.cardPointer-active {
    box-shadow: 5px 5px 10px 5px #dedfe0;
}
.chart-logo {
    width: 80px;
}
</style>



// WEBPACK FOOTER //
// src/view/dashboard/CustomizeDashboard.vue